<button
  mat-icon-button
  [attr.aria-label]="ariaLabel"
  [type]="type"
  [tabIndex]="tabIndex"
  [disabled]="isDisabledState"
  [color]="color"
>
  <div class="button-content">
    <ng-content></ng-content>
    <sn-icon *ngIf="icon">{{ icon }}</sn-icon>
  </div>

  <ng-template [ngIf]="isLoadingState">
    <mat-spinner diameter="24"></mat-spinner>
  </ng-template>
</button>
